import './AppFooter.css';

function AppFooter(){
    return(
    <footer className="app-footer">
    <h3 className='app-made'>
        Made By BabeKung02
    </h3>
    </footer>
)};

export default AppFooter;